import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { SharedService } from "../../services/shared.service";
import { ActivatedRoute, Router } from "@angular/router";
import { formatDate } from "@angular/common";
import {
  customLabels,
  customBankLabels,
  getRiskColor
} from "../../shared/constants";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-scheme-portfolio",
  templateUrl: "./scheme-portfolio.component.html",
  styleUrls: ["./scheme-portfolio.component.scss"]
})
export class SchemePortfolioComponent implements OnInit {
  public schemeId: string;
  public isWatched = false;
  public getRiskColor = getRiskColor;
  public gaugeChart1 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Excellent"
  };
  public gaugeChart2 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Not Attractive",
    upperLimitDisplay: "Very Attractive"
  };
  public gaugeChart3 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Outstanding"
  };
  public gaugeChart4 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Excellent"
  };
  //"Low, Low to Moderate, Moderate, Moderately High, High, Very High"
  public riskometerChart = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Low",
    upperLimitDisplay: "Very High",
    /* chart: {
      lowerLimit: "0",
      upperLimit: "100",
      theme: "fusion",
      showValue: "0", // ✅ Hide numeric dial value

      // ✅ Tick marks only — no numbers
      majorTMNumber: "7",
      majorTMHeight: "15",
      majorTMThickness: "2",
      majorTMColor: "#ffffff",
      minorTMNumber: "0",

      // ✅ Hide all numeric tick labels
      showTickValues: "1",
      showTickMarks: "0",
      showLimits: "100", // ✅ Hide "0" and "100" at edges

      // ✅ Pivot styling
      pivotRadius: "8",
      pivotFillColor: "#333333",

      // ✅ Gauge border
      showGaugeBorder: "1",
      gaugeBorderThickness: "1",
      gaugeBorderAlpha: "50"
    }, */
    chart: {
      lowerLimit: "0",
      upperLimit: "100",
      theme: "fusion",
      showValue: "0",

      // ✅ Hide ticks and numbers — labels replace them
      majorTMNumber: "0",
      minorTMNumber: "0",
      showTickValues: "0",
      showTickMarks: "0",
      showLimits: "0", // ✅ Hide 0 & 100 edge labels

      // ✅ Make gauge radius smaller to leave room for outer labels
      // gaugeOuterRadius: "80", // default ~100 — shrink to give label space
      // gaugeInnerRadius: "60", // controls thickness of arc band

      /* pivotRadius: "8", */
      pivotFillColor: "#333333",
      showGaugeBorder: "10",
      gaugeBorderThickness: "1",
      gaugeBorderAlpha: "50"
    },
    colorRange: {
      color: [
        { minValue: "0", maxValue: "16.67", code: "#00A550", label: "Low" },
        {
          minValue: "16.67",
          maxValue: "33.33",
          code: "#8DC63F",
          label: "Low to Moderate"
        },
        {
          minValue: "33.33",
          maxValue: "50",
          code: "#FFF200",
          label: "Moderate"
        },
        {
          minValue: "50",
          maxValue: "66.67",
          code: "#F7941D",
          label: "Moderately High"
        },
        {
          minValue: "66.67",
          maxValue: "83.33",
          code: "#F15A24",
          label: "High"
        },
        {
          minValue: "83.33",
          maxValue: "100",
          code: "#ED1C24",
          label: "Very High"
        }
      ]
    },

    annotations: {
      showbelow: "0",
      groups: [
        {
          id: "center-value-group",
          items: [
            {
              id: "cv1",
              type: "text",
              text: "Low",
              x: "$gaugeCenterX",
              y: "$gaugeCenterY + 20",
              fontsize: "14",
              bold: "1",
              color: "#00A550",
              align: "center",
              alpha: "100" // ✅ Visible by default (first segment)
            },
            {
              id: "cv2",
              type: "text",
              text: "Low to Moderate",
              x: "$gaugeCenterX",
              y: "$gaugeCenterY + 20",
              fontsize: "14",
              bold: "1",
              color: "#8DC63F",
              align: "center",
              alpha: "0" // ✅ Hidden by default
            },
            {
              id: "cv3",
              type: "text",
              text: "Moderate",
              x: "$gaugeCenterX",
              y: "$gaugeCenterY + 20",
              fontsize: "14",
              bold: "1",
              color: "#ccbb00",
              align: "center",
              alpha: "0"
            },
            {
              id: "cv4",
              type: "text",
              text: "Moderately High",
              x: "$gaugeCenterX",
              y: "$gaugeCenterY + 20",
              fontsize: "14",
              bold: "1",
              color: "#F7941D",
              align: "center",
              alpha: "0"
            },
            {
              id: "cv5",
              type: "text",
              text: "High",
              x: "$gaugeCenterX",
              y: "$gaugeCenterY + 20",
              fontsize: "14",
              bold: "1",
              color: "#F15A24",
              align: "center",
              alpha: "0"
            },
            {
              id: "cv6",
              type: "text",
              text: "Very High",
              x: "$gaugeCenterX",
              y: "$gaugeCenterY + 20",
              fontsize: "14",
              bold: "1",
              color: "#ED1C24",
              align: "center",
              alpha: "0"
            }
          ]
        }
      ]
    },
    /* annotations: {
      showbelow: "0",
      groups: [
        {
          id: "label-group",
          items: [
            {
              id: "l1",
              type: "text",
              text: "Low",
              x: "$gaugeStartX + 145",
              y: "$gaugeCenterY - 5",
              fontsize: "9",
              bold: "1",
              color: "#00A550", // ✅ Match segment color
              rotate: "60",
              align: "center"
            },
            {
              id: "l2",
              type: "text",
              text: "Low to\nModerate",
              x: "$gaugeStartX + 140", // ✅ Over arc — upper left
              y: "$gaugeStartY + 100",
              fontsize: "9",
              bold: "1",
              color: "#8DC63F",
              rotate: "30",
              align: "center"
            },
            {
              id: "l3",
              type: "text",
              text: "Moderate",
              x: "$gaugeCenterX - 40", // ✅ Over arc — top center
              y: "$gaugeStartY + 80",
              fontsize: "9",
              bold: "1",
              color: "#ccbb00", // ✅ Darker yellow for visibility
              rotate: "0",
              align: "center"
            },
            {
              id: "l4",
              type: "text",
              text: "Moderately\nHigh",
              x: "$gaugeEndX - 180", // ✅ Over arc — upper right
              y: "$gaugeStartY + 80",
              fontsize: "9",
              bold: "1",
              color: "#F7941D",
              rotate: "-30",
              align: "center"
            },
            {
              id: "l5",
              type: "text",
              text: "High",
              x: "$gaugeEndX - 165", // ✅ Push further right-outside arc
              y: "$gaugeCenterY - 60",
              fontsize: "9",
              bold: "1",
              color: "#F15A24",
              rotate: "-60",
              align: "center"
            },
            {
              id: "l6",
              type: "text",
              text: "Very High",
              x: "$gaugeEndX - 135", // ✅ Beyond right edge
              y: "$gaugeCenterY - 5",
              fontsize: "9",
              bold: "1",
              color: "#ED1C24",
              rotate: "-75",
              align: "center"
            }
          ]
        }
      ]
    }, */
    dials: {
      dial: [
        {
          value: "0",
          rearExtension: "15",
          borderColor: "#333333",
          borderThickness: "1",
          bgColor: "#333333"
        }
      ]
    }
  };
  public gaugeChart5 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Outstanding"
  };

  public gaugeChart6 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Outstanding"
  };

  public orPortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "Overall Rating", plotBorderThickness: 1 }
  };
  public brPortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: {
      caption: "Business Rating (Only for Equity)",
      plotBorderThickness: 1
    }
  };
  public vrPortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: {
      caption: "Valuation Rating (Only for Equity)",
      plotBorderThickness: 1
    }
  };
  public qrPortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: {
      caption: "Quarterly Trend (Only for Equity)",
      plotBorderThickness: 1
    }
  };
  public debtPortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "Debt Rating Mix", plotBorderThickness: 1 }
  };
  public debtRatingPortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "Debt Rating", plotBorderThickness: 1 }
  };
  public ratingWisePortfolioHoldingsChart = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "Rating Wise ", plotBorderThickness: 1 }
  };
  public qtrRatingle3 = 0;

  public AUMMixChart = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "AUM Mix" }
  };
  public mcapMixChart = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "Mkt Cap Mix" }
  };
  public sectorialMix = [];
  public showSectorialMix = false;
  public sectorialMixFilter = [];
  public schemeHoldings = [];
  public schemeHoldingsFilter = [];
  public schemeComparison = [];
  public schemeComparisonFilter = [];
  public showSchemeComparison = false;
  public showRatingCompanyWise = false;
  public schemeRatioStats = [];
  public showSchemeFofs = false;
  public schemeUnderFof = [];
  public schemeUnderFofFilter = [];

  public overallRatingKeys = [
    {
      title: "sch_name",
      name: "Scheme",
      isLink: 1,
      datatype: "string",
      star: ""
    },
    {
      title: "PERC_HOLD",
      name: "% Holding",
      isLink: 0,
      datatype: "numeric",
      star: ""
    },
    {
      title: "overall_business_rating",
      name: "Business Rating",
      isLink: 0,
      datatype: "star",
      star: "7"
    },
    {
      title: "overall_valuation_rating",
      name: "Valuation Rating",
      isLink: 0,
      datatype: "star",
      star: "5"
    },
    {
      title: "overall_quarterly_rating",
      name: "Quarterly Rating",
      isLink: 0,
      datatype: "star",
      star: "5"
    },
    {
      title: "overall_debt_others_rating",
      name: "Debt & Others Rating",
      isLink: 0,
      datatype: "star",
      star: "7"
    },
    {
      title: "overall_equity_rating",
      name: "Equity Rating",
      isLink: 0,
      datatype: "star",
      star: "7"
    },
    {
      title: "overall_scheme_rating",
      name: "Scheme Rating",
      isLink: 0,
      datatype: "star",
      star: "5"
    }
    // { title: 'overall_weighted_scheme_rating', name: 'Weighted Scheme Rating', isLink: 0,  datatype: 'star', star: '5' },
  ];
  public msLinechartData: Object = {
    type: "msline",
    config: {},
    genConfig: { caption: "NAV Vs BSE 500", showLabels: 1, xAxisname: "" }
  };
  public schemeReturnschartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: {
      caption: "Return Analysis Vs Category Vs Index",
      showLabels: 1,
      xAxisname: ""
    }
  };
  public investmentEquityChartData: Object = {
    type: "msline",
    config: {},
    genConfig: {}
  };
  public investmentDebtChartData: Object = {
    type: "msline",
    config: {},
    genConfig: {}
  };
  public schemeReturnsFields = [
    {
      title: "1WEEK",
      bsubtitle: "_1WRet",
      subtitle: "WEEK",
      schname: "w",
      name: "1W",
      datatype: "numeric"
    },
    {
      title: "1MONTH",
      bsubtitle: "_1MRet",
      subtitle: "1M",
      schname: "1m",
      name: "1M",
      datatype: "numeric"
    },
    {
      title: "3MONTH",
      bsubtitle: "_3MRet",
      subtitle: "3M",
      schname: "3m",
      name: "3M",
      datatype: "numeric"
    },
    {
      title: "6MONTH",
      bsubtitle: "_6MRet",
      subtitle: "6M",
      schname: "6m",
      name: "6M",
      datatype: "numeric"
    },
    {
      title: "1YEAR",
      bsubtitle: "_1YRet",
      subtitle: "1YR",
      schname: "1yr",
      name: "1Yr",
      datatype: "numeric"
    },
    {
      title: "3YEAR",
      bsubtitle: "_3YRet",
      subtitle: "3YR",
      schname: "3yr",
      name: "3Yr",
      datatype: "numeric"
    },
    {
      title: "5YEAR",
      bsubtitle: "_5YRet",
      subtitle: "5YR",
      schname: "5yr",
      name: "5Yr",
      datatype: "numeric"
    },
    {
      title: "inception",
      bsubtitle: "_IncRet",
      subtitle: "INC",
      schname: "inc",
      name: "Since Inception",
      datatype: "numeric"
    }
  ];
  public schemeReturnsRows = [
    {
      title: "1",
      name: "This Scheme",
      subtitle: "",
      datatype: "numeric"
    },
    {
      title: "BM",
      name: "Benchmark",
      subtitle: "",
      datatype: "numeric"
    },
    {
      title: "MAX",
      name: "Best in Category",
      subtitle: "maxname",
      datatype: "numeric"
    },
    {
      title: "MIN",
      name: "Worst in Category",
      subtitle: "minname",
      datatype: "numeric"
    },
    {
      title: "AVG",
      name: "AVG in Category",
      subtitle: "",
      datatype: "numeric"
    }
  ];

  public schemeRatioColumns = [
    {
      title: "min",
      name: "Min",
      subtitle: "",
      datatype: "numeric"
    },
    {
      title: "max",
      name: "Max",
      subtitle: "",
      datatype: "numeric"
    },
    {
      title: "median",
      name: "Median",
      subtitle: "",
      datatype: "numeric"
    },
    {
      title: "mean",
      name: "Mean",
      subtitle: "",
      datatype: "numeric"
    }
  ];
  public schemeRatioRows = [];

  public schemeRatioAvgchartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "Average", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioAlphachartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "Alpha", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioBetachartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "Beta", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioPtratiochartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "PTRatio", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioRQchartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "RSQUARE", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioSDchartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "SD", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioSharpechartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "SHARPE", showLabels: 1, xAxisname: "" }
  };
  public schemeRatioTrchartData: Object = {
    type: "mscolumn2d",
    config: {},
    genConfig: { caption: "TREYNOR", showLabels: 1, xAxisname: "" }
  };

  public rollingReturnAnalysisRow = [
    {
      title: "bse_500_rr",
      subtitle: "",
      name: "BSE 500",
      datatype: "string",
      unit: ""
    },
    {
      title: "bse_sensex_rr",
      subtitle: "",
      name: "BSE Sensex",
      datatype: "string",
      unit: ""
    }
  ];

  public rollingReturnAnalysis = [
    {
      title: "nav_rr_grtr_than_",
      titleSuffix: "",
      name: "Consistency",
      datatype: "numeric",
      unit: ""
    },
    {
      title: "nav_greater_than_positive_",
      titleSuffix: "",
      name: "Upside",
      datatype: "numeric",
      unit: ""
    },
    {
      title: "nav_less_than_negative_",
      titleSuffix: "",
      name: "Downside",
      datatype: "numeric",
      unit: ""
    }
  ];
  public rollingReturnMeanSD = [
    {
      title: "mean",
      subTitle: "NAV_RR",
      name: "Mean",
      datatype: "numeric",
      unit: ""
    },
    {
      title: "standard_deviation",
      subTitle: "NAV_RR",
      name: "SD",
      datatype: "numeric",
      unit: ""
    }
  ];

  public rollingReturnsData = {};

  public growthValueData = [];
  public growthValueKeys = [];
  public growthValueKeysTotal = [];

  public AUMEquity = 0;

  public userInfo: any;
  public showPlans = false;
  public visitCnt = 0;
  public portfolioData: any;
  public isETF: boolean = false;
  public mainCategory: any;

  objectKeys = Object.keys;

  constructor(
    private _api: ApiService,
    public _shared: SharedService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _toast: ToastrService
  ) {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.userInfo = this._shared.userInfo;
  }

  ngOnInit() {
    // console.log('id', this._route.snapshot.paramMap.get('id'), (this._route.snapshot.paramMap.get('id') === null));
    this.schemeId =
      this._route.snapshot.paramMap.get("id") === null
        ? "110"
        : this._route.snapshot.paramMap.get("id");
    this.getPortfolio();
  }

  getPortfolio() {
    this._api.getSchemePortfolio(this.schemeId).subscribe(response => {
      //console.log("1 getPortfolio###=> ", response);

      //this.riskometerChart.value
      if (response.status === "success") {
        this.portfolioData = response.data;

        if (this.portfolioData.MainCategory) {
          this.mainCategory = this.portfolioData.MainCategory;
        } else {
          this.mainCategory = "";
        }

        //Sanjay
        //portfolioData?.riskometervalue
        if (this.portfolioData.riskometervalue === "Low") {
          //this.riskometerChart.dials.dial[0].value = "50";
          this.riskometerChart.value = 9;
        } else if (this.portfolioData.riskometervalue === "Moderate") {
          //this.riskometerChart.dials.dial[0].value = "40";
          this.riskometerChart.value = 42;
        } else if (this.portfolioData.riskometervalue === "Moderately Low") {
          //this.riskometerChart.dials.dial[0].value = "25";
          this.riskometerChart.value = 25;
        } else if (this.portfolioData.riskometervalue === "Moderately High") {
          //this.riskometerChart.dials.dial[0].value = "60";
          this.riskometerChart.value = 58;
        } else if (this.portfolioData.riskometervalue === "High") {
          //this.riskometerChart.dials.dial[0].value = "75";
          this.riskometerChart.value = 75;
        } else if (this.portfolioData.riskometervalue === "Very High") {
          //this.riskometerChart.dials.dial[0].value = "90";
          this.riskometerChart.value = 92;
        }

        /* this.riskometerChart.dials: {
          dial: [
            {
              value: this.portfolioData.riskometervalue === 'Very High' && "160",
              rearExtension: "15",
              borderColor: "#333333",
              borderThickness: "1",
              bgColor: "#333333"
            }
          ]
        } */
        //this.riskometerChart.value = this.portfolioData.riskometervalue === 'Very High' && "160";

        var portfolioLastUpdatedDate = this.portfolioData.date
          .split("T")[0]
          .split("-");

        //console.log(portfolioLastUpdatedDate);

        this.portfolioData.date =
          portfolioLastUpdatedDate[2] +
          "-" +
          portfolioLastUpdatedDate[1] +
          "-" +
          portfolioLastUpdatedDate[0];
        this.portfolioData["SCH_NAME"] = this.portfolioData["SCH_NAME"]
          ? this.portfolioData["SCH_NAME"]
          : this.portfolioData["sch_name"]
          ? this.portfolioData["sch_name"]
          : "N/A";
        if (
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"]["overall_business_rating"]
        ) {
          this.gaugeChart1.value =
            this.portfolioData["frontend_data"]["raw"][
              "overall_business_rating"
            ] &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_business_rating"
            ] != "-"
              ? this.portfolioData["frontend_data"]["raw"][
                  "overall_business_rating"
                ].toFixed(2)
              : 0;
        }
        if (
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"]["overall_valuation_rating"]
        ) {
          this.gaugeChart2.value =
            this.portfolioData["frontend_data"]["raw"][
              "overall_valuation_rating"
            ] &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_valuation_rating"
            ] != "-"
              ? this.portfolioData["frontend_data"]["raw"][
                  "overall_valuation_rating"
                ].toFixed(2)
              : 0;
        }
        if (
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"]["overall_quarterly_rating"]
        ) {
          this.gaugeChart3.value =
            this.portfolioData["frontend_data"]["raw"][
              "overall_quarterly_rating"
            ] &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_quarterly_rating"
            ] != "-"
              ? this.portfolioData["frontend_data"]["raw"][
                  "overall_quarterly_rating"
                ].toFixed(2)
              : 0;
        }

        
        if(this.portfolioData.Category === "ETFs Fund" || this.portfolioData.Category === "FoFs Domestic" || this.portfolioData.Category === "FoFs Overseas"){
          this.isETF = true;
        }else{
          this.isETF = false;
        }

        //console.log('isETF Category >>>', this.isETF, this.portfolioData.MainCategory);

        if (
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"]["overall_scheme_rating"]
        ) {
          /* this.gaugeChart4.value =
            this.portfolioData.Category == "FoFs Domestic" &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_weighted_scheme_rating"
            ] &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_weighted_scheme_rating"
            ] != "-"
              ? this.portfolioData["frontend_data"]["raw"][
                  "overall_weighted_scheme_rating"
                ].toFixed(2)
              : this.portfolioData["frontend_data"]["raw"][
                  "overall_scheme_rating"
                ].toFixed(2); */
          this.gaugeChart4.value = this.portfolioData.Category == "FoFs Domestic" ?  this.portfolioData["frontend_data"]["raw"]["overall_scheme_rating"].toFixed(2) : this.portfolioData["frontend_data"]["raw"]["overall_scheme_rating"].toFixed(2); 
        }
        //console.log("<<< gaugeChart4 >>>", this.gaugeChart4);
        if (
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"][
            "overall_debt_others_rating"
          ]
        ) {
          this.gaugeChart5.value =
            this.portfolioData["frontend_data"]["raw"][
              "overall_debt_others_rating"
            ] &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_debt_others_rating"
            ] != "-"
              ? this.portfolioData["frontend_data"]["raw"][
                  "overall_debt_others_rating"
                ].toFixed(2)
              : 0;
        }
        if (
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"]["overall_equity_rating"]
        ) {
          this.gaugeChart6.value =
            this.portfolioData["frontend_data"]["raw"][
              "overall_equity_rating"
            ] &&
            this.portfolioData["frontend_data"]["raw"][
              "overall_equity_rating"
            ] != "-"
              ? this.portfolioData["frontend_data"]["raw"][
                  "overall_equity_rating"
                ].toFixed(2)
              : 0;
        }
        // Holding Data
        if (
          this.portfolioData.holdings_summary &&
          this.portfolioData["frontend_data"]["raw"]["overall_valuation_rating"]
        ) {
          this.investmentEquityChartData = {
            type: "bubble",
            config: {},
            genConfig: {
              caption: "Investment Style",
              subcaption: "Equity",
              xAxisMinValue: "0",
              xAxisMaxValue: "1",
              yAxisMinValue: "0",
              yAxisMaxValue: "1",
              plotFillAlpha: "70",
              plotFillHoverColor: "#6baa01",
              xAxisName: "Equity Portfolio Rating",
              yAxisName: "Valuation Rating",
              numDivlines: "3",
              showValues: "1",
              yAxisValuesStep: ".3",
              plotTooltext:
                "$name Portfolio Rating- $xvalue , Valuation Rating $yvalue ",
              drawQuadrant: "1",
              quadrantLineAlpha: "80",
              quadrantLineThickness: "3",
              // quadrantXVal: '50',
              // quadrantYVal: '100',
              quadrantLabelTL: "Low / High",
              quadrantLabelTR: "High / High",
              quadrantLabelBL: "Low / Low",
              quadrantLabelBR: "High / Low",
              use3dlighting: "0",
              showAlternateHGridColor: "0",
              showAlternateVGridColor: "0"
            }
          };
          // s1_p_benchmark
          const equityData = [
            {
              color: "#00aee4",
              data: [
                {
                  x:
                    this.portfolioData["frontend_data"]["raw"][
                      "overall_equity_rating"
                    ] &&
                    this.portfolioData["frontend_data"]["raw"][
                      "overall_equity_rating"
                    ] != "-"
                      ? this.portfolioData["frontend_data"]["raw"][
                          "overall_equity_rating"
                        ].toFixed(2)
                      : 0,
                  y:
                    this.portfolioData["frontend_data"]["raw"][
                      "overall_valuation_rating"
                    ] &&
                    this.portfolioData["frontend_data"]["raw"][
                      "overall_valuation_rating"
                    ] != "-"
                      ? this.portfolioData["frontend_data"]["raw"][
                          "overall_valuation_rating"
                        ].toFixed(2)
                      : 0,
                  z: "1",
                  name: "Equity"
                }
              ]
            }
          ];
          const dataLabels = [
            {
              label: "0",
              x: "0"
            },
            {
              label: "0.3",
              x: "0.3",
              showverticalline: "1"
            },
            {
              label: "0.6",
              x: "0.6",
              showverticalline: "1"
            },
            {
              label: "1",
              x: "1",
              showverticalline: "1"
            }
          ];
          this.investmentEquityChartData["config"] = {
            dataSets: equityData,
            dataLabels: dataLabels
          };
        }

        if (
          this.portfolioData &&
          this.portfolioData["frontend_data"] &&
          this.portfolioData["frontend_data"]["raw"] &&
          this.portfolioData["avg_maturity"] &&
          this.portfolioData["avg_maturity_ModDuration"] !== null
        ) {
          let avgMaturity = this.portfolioData["avg_maturity"].split(" ");
          let avg_maturity_ModDuration = this.portfolioData[
            "avg_maturity_ModDuration"
          ].split(" ");
          this.investmentDebtChartData = {
            type: "bubble",
            config: {},
            genConfig: {
              caption: "Investment Style",
              subcaption: "Debt",
              xAxisMinValue: "0",
              xAxisMaxValue: "1",
              yAxisValuesStep: "1",
              yAxisMinValue: "0",
              yAxisMaxValue: Math.ceil(parseFloat(avgMaturity[0])) + 1,
              showValues: "1",
              showLabels: 1,
              xAxisName: "Debt Rating",
              yAxisName: "Modified Duration",
              quadrantLabelTL: "Low / High",
              quadrantLabelTR: "High / High",
              quadrantLabelBL: "Low / Low",
              quadrantLabelBR: "High / Low",
              drawQuadrant: 1,
              plotFillAlpha: "70",
              plotFillHoverColor: "#6baa01",
              plotTooltext:
                "$name Rating $xvalue stars, Modified Duration $yvalue Yrs"
            }
          };
          // const dataSeries = [
          //   { seriesname: 'Average Maturity', data: [], color: '#6f42c1' },
          // ];
          // let dataLabels = [];
          const dataLabels = [
            {
              label: "0",
              x: "0"
            },
            {
              label: "0.3",
              x: "0.3",
              showverticalline: "1"
            },
            {
              label: "0.6",
              x: "0.6",
              showverticalline: "1"
            },
            {
              label: "1",
              x: "1",
              showverticalline: "1"
            }
          ];
          // const businessRatingStars = [1,2,3,4,5,6,7];
          // businessRatingStars.forEach((val, key) => {
          //   dataLabels.push({
          //     label: `${val}`,
          //     x: `${val}`,
          //     showverticalline: '1'
          //     //  + ' Star',
          //     // x: val,
          //     // showverticalline: 0
          //   });
          // });

          /* console.log(
            avgMaturity,
            this.portfolioData["frontend_data"]["raw"][
              "overall_debt_others_rating"
            ],
            parseFloat(avgMaturity[0])
          ); */
          const debtData = [
            {
              color: "#00aee4",
              data: [
                {
                  x: this.portfolioData["frontend_data"]["raw"][
                    "overall_debt_others_rating"
                  ].toFixed(2),
                  y: parseFloat(avg_maturity_ModDuration[0]),
                  z: "10",
                  name: "Debt"
                }
              ]
            }
          ];
          // dataSeries[0].data.push({ value: this.portfolioData['avg_maturity'] });

          this.investmentDebtChartData["config"] = {
            dataSets: debtData,
            dataLabels: dataLabels
          };
          //console.log(this.investmentDebtChartData);
        }

        if (this.portfolioData && this.portfolioData.scheme_returns) {
          this.createSchemeReturnChart();
        }

        if (
          this.portfolioData &&
          this.portfolioData["holdings_summary"] &&
          this.portfolioData["holdings_summary"]["mcaptypewisenew"]
        ) {
          this.growthValueData = this.portfolioData["holdings_summary"][
            "mcaptypewisenew"
          ];
          var growthvalueKeys = Object.keys(
            this.portfolioData["holdings_summary"]["mcaptypewisenew"]["number"]
          );
          let colInd, subTitle;
          growthvalueKeys.forEach((indVal, indKey) => {
            colInd = indVal == "Large Cap" ? 1 : indVal == "Mid Cap" ? 2 : 3;
            subTitle =
              indVal == "Large Cap"
                ? "(> Rs. 20k Crs.)"
                : indVal == "Mid Cap"
                ? "(> Rs. 5k-20K Crs.)"
                : "(< Rs. 5k Crs.)";
            this.growthValueKeys.push({
              sort_order: colInd,
              name: indVal,
              title: indVal,
              subTitle: subTitle
            });
          });

          //console.log(growthvalueKeys, this.growthValueData);

          this.growthValueKeys.push({
            sort_order: 4,
            name: "Total",
            title: "Total",
            subTitle: ""
          });
          this.growthValueKeys.sort((a, b) => a.sort_order - b.sort_order);
          // console.log('growthValueKeys=>>>', this.growthValueKeys);
          const q1_a_greater =
            this.portfolioData["holdings_summary"] &&
            this.portfolioData["holdings_summary"]["mcaptypewisenew"][
              "q1_a_greater"
            ]["PERC_HOLD"];
          const q1_a_greater_number =
            this.portfolioData["holdings_summary"] &&
            this.portfolioData["holdings_summary"]["mcaptypewisenew"][
              "q1_a_greater"
            ]["number"];
          this.calculategrowthValueKeysTotal(
            q1_a_greater,
            q1_a_greater_number,
            "Values"
          );
          const q1_b_greater =
            this.portfolioData["holdings_summary"] &&
            this.portfolioData["holdings_summary"]["mcaptypewisenew"][
              "q1_b_greater"
            ]["PERC_HOLD"];
          const q1_b_greater_number =
            this.portfolioData["holdings_summary"] &&
            this.portfolioData["holdings_summary"]["mcaptypewisenew"][
              "q1_b_greater"
            ]["number"];
          this.calculategrowthValueKeysTotal(
            q1_b_greater,
            q1_b_greater_number,
            "Growth"
          );
          const PERC_HOLD =
            this.portfolioData["holdings_summary"] &&
            this.portfolioData["holdings_summary"]["mcaptypewisenew"][
              "PERC_HOLD"
            ];
          const PERC_HOLD_number =
            this.portfolioData["holdings_summary"] &&
            this.portfolioData["holdings_summary"]["mcaptypewisenew"]["number"];
          this.calculategrowthValueKeysTotal(
            PERC_HOLD,
            PERC_HOLD_number,
            "Total"
          );

          //console.log("final total values=>>===", this.growthValueKeysTotal);
        }

        if (
          this.portfolioData.holdings_summary &&
          this.portfolioData.holdings_summary.typewise
        ) {
          this.AUMEquity = this.portfolioData.holdings_summary.typewise.Equity;
          const aumKeys = Object.keys(
            this.portfolioData.holdings_summary.typewise
          );
          aumKeys.forEach((v, k) => {
            // console.log(k, v);
            this.AUMMixChart.data.push({
              value: this.portfolioData.holdings_summary.typewise[v].toFixed(2),
              label: v,
              isSliced: 0
            });
          });
        }
        if (
          this.portfolioData.holdings_summary &&
          this.portfolioData.holdings_summary.mcaptypewise
        ) {
          const mcapKeys = Object.keys(
            this.portfolioData.holdings_summary.mcaptypewise
          );
          mcapKeys.forEach((v, k) => {
            // console.log(k, v);
            this.mcapMixChart.data.push({
              value: this.portfolioData.holdings_summary.mcaptypewise[
                v
              ].toFixed(2),
              label: v,
              isSliced: 0
            });
          });
        }
        if (
          this.portfolioData.holdings_summary &&
          this.portfolioData.holdings_summary.industrywise
        ) {
          const industryKeys = Object.keys(
            this.portfolioData.holdings_summary.industrywise
          );
          let industryData = [];
          industryKeys.forEach((indVal, indKey) => {
            industryData.push({
              name: indVal,
              value: parseFloat(
                this.portfolioData.holdings_summary.industrywise[
                  indVal
                ].toFixed(2)
              )
            });
          });
          industryData = this._shared.getDataInDesc(industryData, "value");
          this.sectorialMixFilter = this._shared.getDataInDesc(
            industryData,
            "value"
          );
          // console.log(industryData);
          this.sectorialMix = industryData;
          this.sectorialMix = this.sectorialMix.slice(0, 15);
          // console.log(this.sectorialMix, this.sectorialMixFilter);
        }
        this.createPHoldingRatingsCharts();
        this.schemeHoldings = this._shared.getDataInDesc(
          this.portfolioData.scheme_holdings,
          "PERC_HOLD"
        );

        //console.log("before this.schemeHoldings::", this.schemeHoldings);

        this.schemeHoldingsFilter = this._shared.getDataInDesc(
          this.portfolioData.scheme_holdings,
          "PERC_HOLD"
        );
        this.schemeComparisonFilter = this.sortSchemeComparision(
          this.portfolioData.scheme_comparison
        );

        /* console.log(
          "this.schemeComparisonFilter >###>>",
          this.schemeComparisonFilter
        ); */

        this.schemeComparison = this.sortSchemeComparision(
          this.portfolioData.scheme_comparison
        );
        this.schemeComparison = this.schemeComparison.slice(0, 5);

        //console.log("###this.schemeComparison >###>>", this.schemeComparison);

        this.schemeHoldings = this.schemeHoldings.slice(0, 5);
        //console.log("after this.schemeHoldings::", this.schemeHoldings);
        if (
          this.portfolioData.frontend_data &&
          this.portfolioData.frontend_data.schemes_under_fof
        ) {
          this.schemeUnderFof = this.portfolioData.frontend_data.schemes_under_fof;
          var filterdSchemsUnderFof = this.portfolioData.frontend_data
            .schemes_under_fof;
          this.schemeUnderFofFilter = filterdSchemsUnderFof.slice(0, 5);
        }
        //console.log(this.portfolioData.scheme_rolling_returns);
        if (this.portfolioData && this.portfolioData.scheme_rolling_returns) {
          this.portfolioData.scheme_rolling_returns.forEach((val, key) => {
            if (val.DURATION == "1Y") {
              this.rollingReturnsData = val;
              // this.rollingReturnAnalysisRow.forEach((data, dataKey) => {
              //   this.rollingReturnAnalysis.forEach((data, dataKey) => {
              //   this.rollingReturnsData[data.title] =
              // });
            }
          });
        }
        //console.log("Scheme Rolling Return", this.rollingReturnsData);
        // console.log(this.schemeComparison, this.schemeComparisonFilter);
        // console.log(this.gaugeChart1, this.gaugeChart1.value, this.AUMMixChart);
        this.createBSEGraph();
        if (this.portfolioData.scheme_ratio_stats) {
          this.schemeRatioStats = this.portfolioData.scheme_ratio_stats;
          const schemeRatioKeys = Object.keys(
            this.portfolioData.scheme_ratio_stats
          );
          schemeRatioKeys.forEach((v, k) => {
            // console.log(k, v);
            this.schemeRatioRows.push({
              title: v,
              name: v,
              subtitle: "",
              datatype: "numeric"
            });
          });
          //console.log(this.schemeRatioRows);
          this.createSchemeRatioGraph();
        }
      }
    });
  }

  /*  getRiskColor(value: string): string {
    //console.log("****value****", value);
    switch (value) {
      case "Low":
        return "#00A550";
      case "Low to Moderate":
        return "#8DC63F";
      case "Moderate":
        return "#dbd21d";
      case "Moderately High":
        return "#F7941D";
      case "High":
        return "#F15A24";
      case "Very High":
        return "#ED1C24";
      default:
        return "#000";
    }
  } */

  calculategrowthValueKeysTotal(data, numberData: any, keyName) {
    //console.log("Growth", data, Object.entries(data));
    if (Object.entries(data).length) {
      let percentSum: any = 0;
      let numberSum: any = 0;
      for (const [item, key] of Object.entries(data)) {
        // console.log('item=>', item);
        //console.log("key-->>>", key);
        percentSum += key;
        numberSum += numberData[item];
      }
      let sumData = { key: keyName, total: percentSum, number: numberSum };
      this.growthValueKeysTotal.push(sumData);
    } else {
      let sumData = { key: keyName, total: "-", number: "-" };
      this.growthValueKeysTotal.push(sumData);
    }
    //console.log("growthValueKeysTotal", this.growthValueKeysTotal);
  }

  createPHoldingRatingsCharts() {
    if (
      this.portfolioData &&
      this.portfolioData.holdings_summary &&
      this.portfolioData.holdings_summary.psumratingwise
    ) {
      const businessRatingStars = [1, 2, 3, 4, 5, 6, 7];
      businessRatingStars.forEach((val, key) => {
        // console.log(val, key);
        const colorK = key + 1; // this.objectKeys(this.portfolioData.business_rating).length - key;
        // console.log(colorK);
        const color =
          colorK === 1
            ? "#FF0000"
            : colorK === 2
            ? "#F0534F"
            : colorK === 3
            ? "#F2726F"
            : colorK === 4
            ? "#f2963f"
            : colorK === 5
            ? "#FFC533"
            : colorK === 6
            ? "#62B58F"
            : "#006400";
        // console.log(colorK, color);
        if (this.portfolioData.holdings_summary.psumratingwise.z1_rating[val]) {
          this.orPortfolioHoldingsChart.data.push({
            value: this._shared.getFixed(
              this.portfolioData.holdings_summary.psumratingwise.z1_rating[
                val
              ] * 100
            ),
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
        } else {
          this.orPortfolioHoldingsChart.data.push({
            value: "0",
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
        }
        if (
          this.portfolioData.holdings_summary.psumratingwise.business_rating[
            val
          ]
        ) {
          this.brPortfolioHoldingsChart.data.push({
            value: this._shared.getFixed(
              this.portfolioData.holdings_summary.psumratingwise
                .business_rating[val] * 100
            ),
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
        } else {
          this.brPortfolioHoldingsChart.data.push({
            value: "0",
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
        }
        if (
          this.portfolioData.holdings_summary.psumratingwise.debt_rating[val]
        ) {
          this.debtPortfolioHoldingsChart.data.push({
            value: this._shared.getFixed(
              this.portfolioData.holdings_summary.psumratingwise.debt_rating[
                val
              ] * 100
            ),
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
          this.debtRatingPortfolioHoldingsChart.data.push({
            value: this._shared.getFixed(
              this.portfolioData.holdings_summary.psumratingwise.debt_rating[
                val
              ] * 100
            ),
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
        } else {
          this.debtPortfolioHoldingsChart.data.push({
            value: "0",
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
          this.debtRatingPortfolioHoldingsChart.data.push({
            value: "0",
            label: colorK + " Star",
            isSliced: 0,
            color: color
          });
        }
      });
      // console.log(this.brPortfolioHoldingsChart);
      // console.log(this.debtPortfolioHoldingsChart);

      let ratingWiseColor = [
        "28a745",
        "36a2eb",
        "6f42c1",
        "FF0000",
        "F0534F",
        "F2726F",
        "f2963f",
        "FFC533",
        "62B58F",
        "006400"
      ];
      ratingWiseColor.reverse();
      this.portfolioData.holdings_summary.ratingwise.forEach((item, index) => {
        // console.log('item', item);
        this.ratingWisePortfolioHoldingsChart.data.push({
          value: this._shared.getFixed(item.PERC_HOLD * 100),
          label: `${item.name}`,
          isSliced: 0,
          color: `#${ratingWiseColor[index]}`
        });
      });

      const vrORqrRatingStars = [1, 2, 3, 4, 5];
      vrORqrRatingStars.forEach((val, key) => {
        const colorK = key + 1; // this.objectKeys(this.portfolioData.holdings_summary.psumratingwise).length - key;
        const color =
          colorK === 1
            ? "#FF0000"
            : colorK === 2
            ? "#F2726F"
            : colorK === 3
            ? "#FFC533"
            : colorK === 4
            ? "#62B58F"
            : "#006400";
        // console.log(colorK, color);
        this.vrPortfolioHoldingsChart.data.push({
          value: this._shared.getFixed(
            this.portfolioData.holdings_summary.psumratingwise.valuation_rating[
              val
            ] * 100
          ),
          label: colorK + " Star",
          isSliced: 0,
          color: color
        });
        if (colorK < 4) {
          this.qtrRatingle3 =
            this.qtrRatingle3 +
            this.portfolioData.holdings_summary.psumratingwise.quarterly_rating[
              val
            ];
        }
        // console.log(colorK, this.qtrRatingle3);
        this.qrPortfolioHoldingsChart.data.push({
          value: this._shared.getFixed(
            this.portfolioData.holdings_summary.psumratingwise.quarterly_rating[
              val
            ] * 100
          ),
          label: colorK + " Star",
          isSliced: 0,
          color: color
        });
      });
      // console.log(this.vrPortfolioHoldingsChart);
      // console.log(this.qrPortfolioHoldingsChart);
    }
  }

  createBSEGraph() {
    if (
      this.portfolioData &&
      this.portfolioData.bse_nav_graph_data &&
      this.portfolioData.bse_nav_graph_data.graph
    ) {
      //console.log("this.portfolioData SCH_NAME", this.portfolioData);
      const dataSeries = [
        {
          seriesname: this.portfolioData["SCH_NAME"],
          data: [],
          color: "#6f42c1"
        },
        { seriesname: "BSE 500", data: [], color: "#17a2b8" },
        { seriesname: "BSE SENSEX", data: [], color: "#28a745" }
      ];
      const dataLabels = [];
      this.portfolioData.bse_nav_graph_data.graph.forEach((val, key) => {
        var UpdatedDate = val.date.split("T")[0].split("-");
        var formattedDate =
          UpdatedDate[0] + "-" + UpdatedDate[2] + "-" + UpdatedDate[1];
        const dateL = new Date(formattedDate);
        const dateLabel =
          dateL.getFullYear() +
          "-" +
          (dateL.getMonth() + 1) +
          "-" +
          dateL.getDate();
        // console.log(UpdatedDate, formattedDate, dateLabel);
        dataLabels.push({
          label: dateLabel
        });
        if (key === 0) {
          dataSeries[0].data.push({ value: 100 });
          dataSeries[1].data.push({ value: 100 });
          dataSeries[2].data.push({ value: 100 });
        } else {
          const d = (
            (100 * val["NAVRS"]) /
            this.portfolioData.bse_nav_graph_data.graph[0]["NAVRS"]
          ).toFixed(2);
          dataSeries[0].data.push({
            value: d,
            toolText: this.portfolioData["SCH_NAME"] + dateLabel + ", " + d
          });
          const d1 = (
            (100 * val["BSE_500"]) /
            this.portfolioData.bse_nav_graph_data.graph[0]["BSE_500"]
          ).toFixed(2);
          dataSeries[1].data.push({
            value: d1,
            toolText: "BSE 500, " + ", " + dateLabel + ", " + d1
          });
          const d2 = (
            (100 * val["BSE_SENSEX"]) /
            this.portfolioData.bse_nav_graph_data.graph[0]["BSE_SENSEX"]
          ).toFixed(2);
          dataSeries[2].data.push({
            value: d2,
            toolText: "BSE SENSEX, " + ", " + dateLabel + ", " + d2
          });
        }
      });
      //console.log("raw data:", dataLabels, dataSeries);
      this.msLinechartData["config"] = {
        labels: dataLabels,
        dataSets: dataSeries,
        filterValues: this.portfolioData.bse_nav_graph_data.returns
      };
      this.msLinechartData["genConfig"] = {
        caption: "NAV Vs BSE 500 Vs BSE Sensex",
        subCaption: "Last Updated: " + dataLabels[dataLabels.length - 1].label,
        showLabels: 1,
        xAxisname: ""
      };
    }
  }

  createSchemeReturnChart() {
    if (this.portfolioData) {
      this.schemeReturnschartData["genConfig"] = {
        caption: "Return Analysis Vs Category Vs Index",
        subcaption: "",
        xaxisname: "",
        yaxisname: "Returns(In %)",
        formatnumberscale: "1",
        plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
        drawcrossline: "1",
        showLabels: 1,
        showValues: 1,
        placeValuesInside: 1,
        decimals: 2,
        rotateValues: 1
      };
      const dataSeries1 = [
        {
          seriesname: this.portfolioData["SCH_NAME"],
          data: [],
          color: "#6f42c1"
        },
        {
          seriesname:
            "Benchmark (" +
            this.portfolioData.scheme_returns.BenchmarkName +
            ")",
          data: [],
          color: "#17a2b8"
        },
        { seriesname: "Best", data: [], color: "#28a745" },
        { seriesname: "Worst", data: [], color: "#36A2EB" },
        { seriesname: "Avg", data: [], color: "#Fadadd" }
      ];
      const dataLabels = [];
      this.schemeReturnsFields.forEach((field, fieldsKey) => {
        dataLabels.push({
          label: field.name
        });
      });
      this.schemeReturnsFields.forEach((field, fieldsKey) => {
        // console.log(fieldsKey, field.title, field.bsubtitle);
        this.schemeReturnsRows.forEach((row, rowKey) => {
          // console.log(rowKey, typeof rowKey, row);
          if (rowKey === 0) {
            // console.log(row.title, row.subtitle, this.portfolioData.scheme_returns[field.title]);
            const s1 = this.portfolioData.scheme_returns[field.title]
              ? this.portfolioData.scheme_returns[field.title].toFixed(2)
              : "-";
            dataSeries1[0].data.push({
              value: s1,
              toolText:
                this.portfolioData["SCH_NAME"] +
                ", " +
                field.name +
                ", " +
                s1 +
                "%"
            });
          }
          if (rowKey === 1) {
            // console.log(this.portfolioData.scheme_returns[row.title + field.bsubtitle]);
            const s2 = this.portfolioData.scheme_returns[
              row.title + field.bsubtitle
            ]
              ? this.portfolioData.scheme_returns[
                  row.title + field.bsubtitle
                ].toFixed(2)
              : "-";
            dataSeries1[1].data.push({
              value: s2,
              toolText: "Benchmark" + ", " + field.name + ", " + s2 + "%"
            });
          }
          if (rowKey > 1) {
            if (field.title === "6MONTH" && row.title === "MIN") {
              // console.log(this.portfolioData.scheme_returns['6' + row.title]);
              const s3 = this.portfolioData.scheme_returns["6" + row.title]
                ? this.portfolioData.scheme_returns["6" + row.title].toFixed(2)
                : "-";
              dataSeries1[rowKey].data.push({
                value: s3,
                toolText:
                  dataSeries1[rowKey].seriesname +
                  ", " +
                  field.name +
                  ", " +
                  s3 +
                  "%"
              });
            } else {
              // console.log(this.portfolioData.scheme_returns[field.subtitle + row.title]);
              const s3 = this.portfolioData.scheme_returns[
                field.subtitle + row.title
              ]
                ? this.portfolioData.scheme_returns[
                    field.subtitle + row.title
                  ].toFixed(2)
                : "-";
              dataSeries1[rowKey].data.push({
                value: s3,
                toolText:
                  dataSeries1[rowKey].seriesname +
                  ", " +
                  field.name +
                  ", " +
                  s3 +
                  "%"
              });
            }
          }
        });
      });
      // console.log(dataSeries1, dataLabels);
      // remove Benchmark from index 1
      dataSeries1.splice(1, 1);
      this.schemeReturnschartData["config"] = {
        labels: dataLabels,
        dataSets: dataSeries1,
        filterValues: []
      };
      // console.log(this.schemeReturnschartData);
    }
  }

  createSchemeRatioGraph() {
    this.schemeRatioAvgchartData["genConfig"] = {
      caption: "Average",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioAlphachartData["genConfig"] = {
      caption: "Alpha",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioBetachartData["genConfig"] = {
      caption: "Beta",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioPtratiochartData["genConfig"] = {
      caption: "PTRatio",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "0",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioRQchartData["genConfig"] = {
      caption: "RSQUARE",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioSDchartData["genConfig"] = {
      caption: "SD",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioSharpechartData["genConfig"] = {
      caption: "SHARPE",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    this.schemeRatioTrchartData["genConfig"] = {
      caption: "TREYNOR",
      subcaption: "",
      xaxisname: "",
      yaxisname: "Ratio",
      formatnumberscale: "1",
      plottooltext: "<b>$dataValue</b> <b>$seriesName</b> in $label%",
      drawcrossline: "1",
      placeValuesInside: 0,
      decimals: "2",
      rotateValues: 0,
      showLabels: 1,
      showValues: 1,
      showLegend: 0
    };
    const dataSeries1 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries2 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries3 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries4 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries5 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries6 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries7 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    const dataSeries8 = [
      { seriesname: this.portfolioData["SCH_NAME"], data: [], color: "#6f42c1" }
    ];
    let dataLabels = [];
    dataLabels.push({
      label: this.portfolioData["SCH_NAME"]
    });
    this.schemeRatioColumns.forEach((field, fieldsKey) => {
      dataLabels.push({
        label: field.name
      });
    });
    //Scheme Data
    const colorScheme = "#6f42c1";
    // let s1 = (this.portfolioData.scheme_ratio['AVERAGE']) ?
    // (this.portfolioData.scheme_ratio['AVERAGE']).toFixed(2) : '-';
    let s1 = this.portfolioData.scheme_ratio["AVERAGE"];
    dataSeries1[0].data.push({
      value: s1,
      color: colorScheme,
      toolText:
        "AVERAGE" + ", " + this.portfolioData["SCH_NAME"] + ", " + s1 + ""
    });
    // let a1 = (this.portfolioData.scheme_ratio['ALPHA']) ?
    // (this.portfolioData.scheme_ratio['ALPHA']).toFixed(2) : '-';
    let a1 = this.portfolioData.scheme_ratio["ALPHA"];
    dataSeries2[0].data.push({
      value: a1,
      color: colorScheme,
      toolText: "ALPHA" + ", " + this.portfolioData["SCH_NAME"] + ", " + a1 + ""
    });
    // let b1 = (this.portfolioData.scheme_ratio['BETA']) ?
    // (this.portfolioData.scheme_ratio['BETA']).toFixed(2) : '-';
    let b1 = this.portfolioData.scheme_ratio["BETA"];
    dataSeries3[0].data.push({
      value: b1,
      color: colorScheme,
      toolText: "BETA" + ", " + this.portfolioData["SCH_NAME"] + ", " + b1 + ""
    });
    // let p1 = (this.portfolioData['PTRatio']) ?
    // (this.portfolioData['PTRatio']).toFixed(2) : '-';
    let p1 = this.portfolioData["PTRatio"];
    dataSeries4[0].data.push({
      value: p1,
      color: colorScheme,
      toolText:
        "PTRatio" + ", " + this.portfolioData["SCH_NAME"] + ", " + p1 + ""
    });
    // let rq1 = (this.portfolioData.scheme_ratio['RSQUARE']) ?
    // (this.portfolioData.scheme_ratio['RSQUARE']).toFixed(2) : '-';
    let rq1 = this.portfolioData.scheme_ratio["RSQUARE"];
    dataSeries5[0].data.push({
      value: rq1,
      color: colorScheme,
      toolText:
        "RSQUARE" + ", " + this.portfolioData["SCH_NAME"] + ", " + rq1 + ""
    });
    // let sd1 = (this.portfolioData.scheme_ratio['SD']) ?
    // (this.portfolioData.scheme_ratio['SD']).toFixed(2) : '-';
    let sd1 = this.portfolioData.scheme_ratio["SD"];
    dataSeries6[0].data.push({
      value: sd1,
      color: colorScheme,
      toolText: "SD" + ", " + this.portfolioData["SCH_NAME"] + ", " + sd1 + ""
    });
    // let sh1 = (this.portfolioData.scheme_ratio['SHARPE']) ?
    // (this.portfolioData.scheme_ratio['SHARPE']).toFixed(2) : '-';
    let sh1 = this.portfolioData.scheme_ratio["SHARPE"];
    dataSeries7[0].data.push({
      value: sh1,
      color: colorScheme,
      toolText:
        "SHARPE" + ", " + this.portfolioData["SCH_NAME"] + ", " + sh1 + ""
    });
    // let t1 = (this.portfolioData.scheme_ratio['TREYNOR']) ?
    // (this.portfolioData.scheme_ratio['TREYNOR']).toFixed(2) : '-';
    let t1 = this.portfolioData.scheme_ratio["TREYNOR"];
    dataSeries8[0].data.push({
      value: t1,
      color: colorScheme,
      toolText:
        "TREYNOR" + ", " + this.portfolioData["SCH_NAME"] + ", " + t1 + ""
    });
    //MAX MIN AVG MEAN
    this.schemeRatioColumns.forEach((field, fieldsKey) => {
      // console.log(field, fieldsKey);
      var colorK = fieldsKey + 1;
      const color =
        colorK === 1
          ? "#Fadadd"
          : colorK === 2
          ? "#F2726F"
          : colorK === 3
          ? "#28a745"
          : colorK === 4
          ? "#36A2EB"
          : "#006400";
      // let s2 = (this.portfolioData.scheme_ratio_stats['AVERAGE'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['AVERAGE'][field.title]).toFixed(2) : '-';
      let s2 = this.portfolioData.scheme_ratio_stats["AVERAGE"][field.title];
      dataSeries1[0].data.push({
        value: s2,
        color: color,
        toolText: "AVERAGE" + ", " + field.name + ", " + s2 + ""
      });
      // let a2 = (this.portfolioData.scheme_ratio_stats['ALPHA'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['ALPHA'][field.title]).toFixed(2) : '-';
      let a2 = this.portfolioData.scheme_ratio_stats["ALPHA"][field.title];
      dataSeries2[0].data.push({
        value: a2,
        color: color,
        toolText: "ALPHA" + ", " + field.name + ", " + a2 + ""
      });
      // let b2 = (this.portfolioData.scheme_ratio_stats['BETA'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['BETA'][field.title]).toFixed(2) : '-';
      let b2 = this.portfolioData.scheme_ratio_stats["BETA"][field.title];
      dataSeries3[0].data.push({
        value: b2,
        color: color,
        toolText: "BETA" + ", " + field.name + ", " + b2 + ""
      });
      // let p2 = (this.portfolioData.scheme_ratio_stats['PTRatio'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['PTRatio'][field.title]).toFixed(2) : '-';
      let p2 = this.portfolioData.scheme_ratio_stats["PTRatio"][field.title];
      dataSeries4[0].data.push({
        value: p2,
        color: color,
        toolText: "PTRatio" + ", " + field.name + ", " + p2 + ""
      });
      // let rq2 = (this.portfolioData.scheme_ratio_stats['RSQUARE'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['RSQUARE'][field.title]).toFixed(2) : '-';
      let rq2 = this.portfolioData.scheme_ratio_stats["RSQUARE"][field.title];
      dataSeries5[0].data.push({
        value: rq2,
        color: color,
        toolText: "RSQUARE" + ", " + field.name + ", " + rq2 + ""
      });
      // let sd2 = (this.portfolioData.scheme_ratio_stats['SD'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['SD'][field.title]).toFixed(2) : '-';
      let sd2 = this.portfolioData.scheme_ratio_stats["SD"][field.title];
      dataSeries6[0].data.push({
        value: sd2,
        color: color,
        toolText: "SD" + ", " + field.name + ", " + sd2 + ""
      });
      // let sh2 = (this.portfolioData.scheme_ratio_stats['SHARPE'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['SHARPE'][field.title]).toFixed(2) : '-';
      let sh2 = this.portfolioData.scheme_ratio_stats["SHARPE"][field.title];
      dataSeries7[0].data.push({
        value: sh2,
        color: color,
        toolText: "SHARPE" + ", " + field.name + ", " + sh2 + ""
      });
      // let t2 = (this.portfolioData.scheme_ratio_stats['TREYNOR'][field.title]) ?
      // (this.portfolioData.scheme_ratio_stats['TREYNOR'][field.title]).toFixed(2) : '-';
      let t2 = this.portfolioData.scheme_ratio_stats["TREYNOR"][field.title];
      dataSeries8[0].data.push({
        value: t2,
        color: color,
        toolText: "TREYNOR" + ", " + field.name + ", " + t2 + ""
      });
    });
    //console.log(dataSeries1, dataLabels);
    this.schemeRatioAvgchartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries1,
      filterValues: []
    };
    this.schemeRatioAlphachartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries2,
      filterValues: []
    };
    this.schemeRatioBetachartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries3,
      filterValues: []
    };
    this.schemeRatioPtratiochartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries4,
      filterValues: []
    };
    this.schemeRatioRQchartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries5,
      filterValues: []
    };
    this.schemeRatioSDchartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries6,
      filterValues: []
    };
    this.schemeRatioSharpechartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries7,
      filterValues: []
    };
    this.schemeRatioTrchartData["config"] = {
      labels: dataLabels,
      dataSets: dataSeries8,
      filterValues: []
    };
  }

  showSchemeRating() {
    this.showSchemeComparison = !this.showSchemeComparison;
  }

  showSchemeHoldings() {
    this.showRatingCompanyWise = !this.showRatingCompanyWise;
  }

  showAllSectorial() {
    this.showSectorialMix = !this.showSectorialMix;
  }

  getPrint() {
    this._shared.printDoc("print-content", "stock-details");
  }

  getRatingStatement(str) {
    return str.substring(0, str.length - 1);
  }

  getRatingValue(value) {
    return value[value.length - 1] < 8 ? value[value.length - 1] : "";
    // return value.substring(-1);
  }

  sortSchemeComparision(data) {
    //console.log("data:::", data);
    return data.sort((a, b) => {
      try {
        return a.frontend_data.raw.overall_scheme_rating <
          b.frontend_data.raw.overall_scheme_rating
          ? 1
          : b.frontend_data.raw.overall_scheme_rating <
            a.frontend_data.raw.overall_scheme_rating
          ? -1
          : 0;
      } catch (e) {
        return 1;
      }
      /*  return a.frontend_data.raw.overall_scheme_rating < b.frontend_data.raw.overall_scheme_rating ? 1
        : b.frontend_data.raw.overall_scheme_rating < a.frontend_data.raw.overall_scheme_rating ? -1 : 0; */
    });
  }

  gotoPlans() {
    //console.log("go to plan");
    // this.showPlans = true;
    this._shared.toggleBenefits();
    // const showPlans = this._shared.toggleBenefits();
  }

  addToWatchlist() {
    this._api
      .addSchemeToWatchlist({
        mf_schcode: parseInt(this.schemeId),
        navrs: this.portfolioData.NAV
      })
      .subscribe(response => {
        if (response.responseType === "Success") {
          this._toast.success(response.message);
          this.isWatched = true;
        } else {
          this._toast.error(response.message);
        }
      });
  }
}
